import { getApiGalaxyServer } from 'services';
import { SearchTeamsByFieldsPayload } from 'TeamModule/api/searchTeamsByFieldsApi';

export interface TeamPendingDeletion {
  id: string;
  tenant: string;
  realmId: string;
  teamId: string;
  name: string;
  dataDeletionScheduledDate?: string;
  archivedAt?: string;
  developerApproved: boolean;
  developerApprover?: string;
  developerApprovedAt?: string;
  supportApproved: boolean;
  supportApprover?: string;
  supportApprovedAt?: string;
  reasonToArchive?: string;
  realmArchived?: boolean;
}

export interface GetTeamsPendingDeletionResponse {
  data: TeamPendingDeletion[];
  total: number;
  page: number;
  limit: number;
}

export const getTeamsPendingDeletionApi = ({
  params,
  token,
  config,
}: BaseApiParams<SearchTeamsByFieldsPayload>) =>
  getApiGalaxyServer(`/lookup/teams/searchByFields`, { ...config, params: params as any }, token);
